<template>
    <component :is="suggestion || isFile ? 'div' : 'label'" class="form-group__label" :class="labelClassArray">
        <div
            class="form-group__label-reset"
            v-if="hasReset && this.value != '' && !disabled"
            @click="$emit('input', '')">
            <svg-icon name="close--small" width="8" height="8" />
        </div>
        <div
            class="form-group__label-reset"
            v-if="suggestion && this.value != '' && !disabled"
            @click="resetCity(true)">
            <svg-icon name="close--small" width="8" height="8" />
        </div>
        <div
            class="form-group__label-reset form-group__label-reset--password"
            v-if="type == 'password'"
            @click="showPassword = !showPassword">
            <svg-icon :name="showPassword ? 'eye--close' : 'eye'" width="16" height="16" />
        </div>
        <template v-if="suggestion">
            <DaDataSuggestions
                @select="setCity($event)"
                :resetting="resetting"
                :inputClass="inputClassArray"
                :country="country"
                :disabled="disabled"
                :initValue="value"
                @reset="resetCity()"
                @update:resetting="
                    resetting = $event;
                    $emit('update:resetting', $event);
                "
                @update:isCityPreload="$emit('update:isCityPreload', $event)"
                @focus="$emit('focus')"
                @blur="$emit('blur')" />
            <div class="form-group__float-label text_11">
                {{ label }}
                <nuxt-link
                    v-if="name == 'agree'"
                    target="_blank"
                    to="/dokumenty/soglashenie-ob-obrabotke-persnonalnyh-dannyh/"
                    >персональных данных</nuxt-link
                >
                <span v-if="required" class="form-group__required">*</span>
            </div>
        </template>
        <template v-else>
            <cleave
                v-if="cleaveOptions"
                :options="fullCleaveOptions"
                :type="type"
                :name="name"
                :value="value"
                @focus.native="isFocus = true"
                @blur.native="isFocus = false"
                :class="inputClassArray"
                :required="required"
                :disabled="disabled"></cleave>
            <template v-else>
                <input
                    v-if="type == 'checkbox'"
                    :type="type"
                    :name="name"
                    :class="inputClassArray"
                    :required="required"
                    :checked="value"
                    @change="$emit('input', $event.target.checked ? 1 : 0)" />
                <input
                    v-else-if="type == 'tel'"
                    type="tel"
                    :name="name"
                    :value="value"
                    :class="inputClassArray"
                    :id="id"
                    :accept="accept"
                    :required="required"
                    :readonly="readonly"
                    :placeholder="placeholder"
                    :disabled="disabled"
                    autocomplete="false_disabled_hack@#!@#$"
                    @focus="isFocus === true, $emit('focus')"
                    @blur="isFocus === false"
                    @change="$emit('change')"
                    @input="onPhoneInput"
                    v-mask="'+# (###) ###-##-##'" />
                <input
                    v-else-if="type == 'tel2'"
                    type="tel"
                    :name="name"
                    :value="value"
                    :class="inputClassArray"
                    :id="id"
                    :readonly="readonly"
                    :accept="accept"
                    :required="required"
                    :placeholder="placeholder"
                    :disabled="disabled"
                    autocomplete="false_disabled_hack@#!@#$"
                    @focus="isFocus === true, $emit('focus')"
                    @blur="isFocus === false"
                    @input="onPhoneInput"
                    @change="$emit('change')"
                    v-mask="'+# (###) ###-##-##'" />
                <input
                    v-else
                    :type="type == 'password' ? (showPassword ? 'text' : type) : type"
                    :name="name"
                    :value="value"
                    @focus="isFocus === true, $emit('focus')"
                    @blur="isFocus === false"
                    :class="inputClassArray"
                    :id="id"
                    :readonly="readonly"
                    :accept="accept"
                    :required="required"
                    :placeholder="placeholder"
                    v-on:input="$emit('input', $event.target.value), $emit('input-with-event', $event)"
                    :disabled="disabled"
                    :autocomplete="autocomplete ? 'one-time-code' : 'false_disabled_hack@#!@#$'"
                    @change="$emit('change')" />
                <label v-if="type == 'file'" :for="id"
                    ><span>{{ !isImage && value ? value.replace(/^.*[\\\/]/, "") : null }}</span></label
                >
            </template>
            <div
                :class="{
                    'form-group__checkbox-label text_11 color-text_3': type == 'checkbox',
                    'form-group__float-label text_11': type != 'checkbox',
                }">
                <span :class="{ 'color-text_1': labelDescription }"
                    >{{ isImage && value ? value.replace(/^.*[\\\/]/, "") : label }}
                    <nuxt-link
                        v-if="name == 'agree'"
                        target="_blank"
                        to="/dokumenty/soglashenie-ob-obrabotke-persnonalnyh-dannyh/"
                        >персональных данных</nuxt-link
                    ></span
                >
                <span class="form-group__required" v-if="required">*</span>
                <span class="form-group__labelDescription" v-if="labelDescription && $device.isDesktop">{{
                    labelDescription
                }}</span>
                <span class="form-group__labelDescription" v-if="labelDescription && !$device.isDesktop">
                    <Hint :hint="labelDescription"></Hint>
                </span>
            </div>
        </template>
        <div
            class="form-group__validation text_11"
            v-if="!innerValidate || name === 'promocode'"
            v-html="validationMessage"></div>
        <nuxt-link
            to="/lk/recover"
            class="form-group__recover-pass text_11 color-text_2"
            v-if="type == 'password' && label == $t('password')"
            >{{ $t("forgot_password") }}?</nuxt-link
        >
    </component>
</template>
<script>
import Cleave from "vue-cleave-component";
import DaDataSuggestions from "~/components/DaDataSuggestions";
import Hint from "~/components/Hint";
import "cleave.js/dist/addons/cleave-phone.i18n.js";
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
export default {
    name: "Input",
    data() {
        return {
            innerValidate: true,
            isFocus: false,
            suggestionValue: null,
            isRequestSended: false,
            showPassword: false,
            resetting: false,
        };
    },
    directives: { mask },
    components: {
        Cleave,
        Hint,
        DaDataSuggestions,
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
        inputClassArray() {
            return [
                this.inputClass ? this.inputClass : "",
                this.type == "checkbox"
                    ? "form-group__checkbox"
                    : this.type == "file"
                    ? this.isImage
                        ? "form-group__image"
                        : "form-group__file"
                    : "form-group__input",
                this.value ? "is_changed" : "",
                this.suggestionValue ? "is_changed" : "",
                this.isFocus ? "is_focus" : "",
                this.innerValidate ? "" : "is_invalid",
            ];
        },
        labelClassArray() {
            return [
                this.labelClass ? this.labelClass : "",
                this.type == "checkbox" ? "form-group__label--checkbox" : "",
                this.type == "hidden" ? "form-group__label--hidden" : "",
                this.placeholder ? "form-group__label--static" : "",
            ];
        },
        fullCleaveOptions() {
            let options = this.cleaveOptions;
            if (options) {
                options.onValueChanged = (e) => {
                    this.emitValue(e.target.value);
                };
                return options;
            }
            return [];
        },
    },
    watch: {
        value(newVal) {
            this.innerValidate = true;

            if (this.required && newVal == "") {
                this.innerValidate = false;
            }

            if (this.name == "email") {
                if (newVal.startsWith(" ") || newVal.endsWith(" ")) {
                    this.emitValue(newVal.replace(/^\s+|\s+$/g, ""));
                }
                if (!this.$grom.validateEmail(newVal)) {
                    this.innerValidate = false;
                }
            }
            if (this.validationMessage != "") {
                this.innerValidate = false;
            }
        },
        isValid(newVal) {
            this.innerValidate = newVal;
        },
        isFocus(val) {
            if (val) {
                this.$emit("focus");
            } else {
                this.$emit("blur");
            }
        },
    },
    props: {
        autocomplete: {
            type: Boolean,
            default: false,
        },
        cleaveOptions: {
            type: [Object, Boolean],
            default() {
                return false;
            },
        },
        isValid: {
            type: Boolean,
            default: true,
        },
        validationMessage: {
            type: String,
            default: "",
        },
        required: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        inputClass: {
            type: String,
        },
        labelClass: {
            type: String,
        },
        type: {
            type: String,
            default: "text",
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: "",
        },
        labelDescription: {
            type: String,
            default: "",
        },
        value: {
            type: [String, Number],
            default: "",
        },

        hasReset: {
            type: Boolean,
            default: false,
        },
        suggestion: {
            type: Boolean,
            default: false,
        },
        isFile: {
            type: Boolean,
            default: false,
        },
        isImage: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: null,
        },
        accept: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: "",
        },
        country: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onPhoneInput(event) {
            this.checkPhoneFormat(event);
            this.$emit("input", event.target.value);
            this.$emit("input-with-event", event);
        },
        emitValue(value) {
            this.$emit("input", value);
        },
        setCity(data) {
            this.$emit("input", data.city);
            this.$emit("change-city", data);
            this.$emit("update:isCityPreload", false);
        },
        resetCity(fromParent) {
            if (fromParent) {
                this.resetting = true;
            }
            this.$emit("input", "");
            this.$emit("change-city", null);
            this.$emit("update:isCityPreload", false);
        },
        checkPhoneFormat(e) {
            if (e.target.value.startsWith("8")) {
                e.target.value = e.target.value.replace("8", "+7");
            }
            if (e.target.value.startsWith("+7 (8")) {
                e.target.value = e.target.value.replace("+7 (8", "+7 (");
            }

            if (
                e.target.value.length === 16 &&
                e.target.value[0] !== "+" &&
                e.target.value[0] !== "7" &&
                e.target.value[0] !== "8"
            ) {
                e.target.value = "+7" + e.target.value;
            }
        },
    },
    created() {
        if (this.suggestion) {
            this.$nuxt.$on("countryChange", () => {
                this.resetCity(true);
            });
        }
    },
};
</script>
<style lang="less">
.form-group {
    input::placeholder {
        color: #000;
    }
    &__checkbox-label {
        user-select: none;
    }
    &__label {
        position: relative;
        margin-top: 34px;
        @media @sm {
            margin-top: 24px;
        }
        &-reset {
            position: absolute;
            z-index: 1;
            top: 50%;
            margin-top: -7px;
            right: -4px;
            padding: 4px;
            cursor: pointer;
            &:hover {
                opacity: 0.5;
            }
            svg {
                display: block;
            }
            @media @sm {
                padding: 16px;
                right: -16px;
                margin-top: -16px;
            }
            &--password {
                top: 0;
                margin-top: 4px;
                @media @sm {
                    right: -8px;
                    padding: 8px;
                    margin-top: 0;
                }
            }
        }
        &--hidden {
            display: none;
        }
        &--static {
            margin-top: 0;
        }
    }
    &__input {
        height: 30px;
        line-height: 16px;
        background: none;
        border-bottom: 1px solid @border2;
        padding-left: 0;
        padding-right: 0;

        &[readonly] {
            border: 1px solid @border2 !important ;
            background: @bg;
            margin-top: 5px;
            padding: 0 10px;
        }

        .trs(border-bottom-color);
        &:hover:not([disabled]):not([readonly]),
        &.is_changed {
            border-bottom-color: #000;
        }
        &.is_invalid {
            border-bottom-color: #f2724a;
        }
        &.text_11 {
            font-size: 11px;
        }
        &.black-border {
            border-bottom: 1px solid #000;
        }
        // &::-webkit-textfield-decoration-container {
        //     display: none !important;
        // }
        // &::-webkit-caps-lock-indicator {
        //     display: none;
        // }

        &::-webkit-credentials-auto-fill-button {
            background-color: white;
            width: 0;
            margin: 0;
        }
        &--promocode {
            height: 33px;
        }
        &::-webkit-inner-spin-button,
        &::-webkit-calendar-picker-indicator {
            display: none;
        }
    }
    &__file {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
        & + label {
            height: 30px;
            background: none;
            border-bottom: 1px solid @border2;
            padding-left: 0;
            padding-right: 0;
            cursor: pointer;
            font-style: normal;
            font-weight: normal;
            font-size: 13px;
            line-height: 100%;
            letter-spacing: 0.16em;
            position: relative;
            span {
                position: absolute;
                bottom: 7px;
                white-space: nowrap;
                overflow: hidden;
                max-width: 95%;
                text-overflow: ellipsis;
            }
        }
        &:hover:not([disabled]) + label,
        &.is_changed + label {
            border-bottom-color: #000;
        }
    }
    &__image {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
        & + label {
            width: 160px;
            height: 160px;
            border: 1px solid @border2;
            transition: border-color 0.3s 0s ease;
            cursor: pointer;
            position: relative;
            & + .form-group__float-label span {
                word-break: break-word;
            }
            span {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 44px;
                height: 44px;
                border-top: 1px solid @border2;
                border-left: 1px solid @border2;
                transition: border-color 0.3s 0s ease;
                position: absolute;
                right: 0;
                bottom: 0;
                &:after {
                    content: "";
                    display: block;
                    width: 8px;
                    height: 8px;
                    background: url(../../assets/icons/plus.svg);
                }
            }
        }
        & + label + .form-group__float-label {
            left: 16px;
            max-width: 128px;
        }
        &:hover + label,
        &:hover + label span,
        &:hover:not([disabled]) + label,
        &.is_changed + label,
        &:hover:not([disabled]) + label span,
        &.is_changed + label span {
            border-color: #000;
        }

        &.is_focus + .form-group__float-label,
        &.is_changed + .form-group__float-label,
        &.is_changed + label + .form-group__float-label {
            transform: translateY(50%);
        }
    }
    &__float-label {
        position: absolute;
        top: 0;
        .trs(all);
        pointer-events: none;
        font-size: 11px;
        color: @text_3;
        transform: translateY(50%);
        display: flex;
        transform-origin: left bottom;
        .is_focus + &,
        .is_changed + &,
        .is_changed + label + & {
            transform: translateY(-14px) scale(0.84);
            pointer-events: all;
        }
    }
    &__required {
        color: #e84a18;
        position: relative;
        bottom: -2px;
        margin-left: 4px;
    }
    &__labelDescription {
        &:before {
            content: "/";
            margin: 0 8px;
        }
        .hint {
            position: static;
        }
        .hint__text {
            left: 0;
        }
    }
    &__validation {
        position: absolute;
        top: 100%;
        color: #f2724a;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-wrap: auto;
        margin-top: 2px;
        @media @sm {
            position: static;
            white-space: normal;
        }
        &--static {
            position: static;
        }
    }
    &__recover-pass {
        margin-top: 4px;
        text-align: right;
        position: absolute;
        right: 0;
        top: 100%;
    }
}
</style>
